import { Injectable } from '@angular/core';

@Injectable()
export class ClassifyFormService {

  constructor() { }

  getPatternHelp() {
    return [
      { pattern: '#', description: 'Each occurance of # is replaced with a random digit', examples: { p: '###', g: '150' }   }
    ];
  }

}
